import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { name: String }
  }

  static get targets() {
    return ["iframe", "loader"]
  }

  connect() {
    App.modal($(this.element), "show")
    App.modalEvent($(this.element), "hidden.bs.modal", () => { this.complete() })

    // Hide loader when iframe loads
    this.iframeTarget.addEventListener('load', () => {
      this.loaderTarget.classList.add('d-none')
    })

    // Add listener to Arcade video
    window.addEventListener("message", (event) => {
      if (event.origin === "https://demo.arcade.software") {
        if (event.data.eventName === "CTA Clicked") {
          this.complete()
        }
      }
    }, false);
  }

  close() {
    App.modal($(this.element), "hide")
  }

  complete() {
    const onboardingStepName = this.nameValue

    fetch("/onboarding/steps", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content")
      },
      body: JSON.stringify({ onboarding_step: { name: onboardingStepName, seen: true } }),
    })
  }
}
